export default "__VITE_ASSET__BIMOmST2__"